import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {useCallback, useMemo} from "react";
import {useSearchParams} from "react-router-dom";
import {getPrevSearchParams} from "@helpers/searchParams/helpers";

export function useAccountIdSingleVoyage(): {
    accountId: string
    setAccountId: (accountId: string) => void
} {
    const {isMultiAccount, account} = useAppContext()
    const [searchParams, setSearchParams] = useSearchParams()

    const ownAccountId = account?.id?.toString() ?? ''
    const paramAccountId = searchParams.get('accountId')

    const accountId = useMemo(() => {
        if (!isMultiAccount) {
            return ownAccountId
        }
        return paramAccountId || ownAccountId
    }, [isMultiAccount, ownAccountId, paramAccountId])

    const setAccountId = useCallback((value: string) => {
        setSearchParams((prev) => {
            return {
                ...getPrevSearchParams(prev),
                accountId: value || ownAccountId
            }
        })
    }, [setSearchParams, ownAccountId])

    return {accountId, setAccountId}
}
